import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MailCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen flex items-center justify-center px-4">
      <div className="jpd-card w-full max-w-md p-8 sm:p-10">
        {sent ? (
          <div className="text-center" data-testid="forgot-password-sent">
            <span className="mx-auto w-14 h-14 rounded-full bg-[#10B981]/15 border border-[#10B981]/40 flex items-center justify-center">
              <MailCheck className="w-6 h-6 text-[#10B981]" />
            </span>
            <h1 className="mt-5 text-xl font-semibold">Check your inbox</h1>
            <p className="mt-2 text-sm text-slate-400">
              If that email is registered, a reset link has been sent.
            </p>
          </div>
        ) : (
          <>
            <h1 className="text-xl sm:text-2xl font-semibold">Reset your password</h1>
            <p className="mt-2 text-sm text-slate-400">
              Enter the email for your owner account and we'll send a reset link.
            </p>
            <form data-testid="forgot-password-form" onSubmit={submit} className="mt-6 space-y-4">
              <input
                data-testid="forgot-password-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="jpd-input"
                autoComplete="email"
              />
              <button
                data-testid="forgot-password-submit-button"
                disabled={loading}
                className="w-full bg-primary hover:bg-[#C20A0B] disabled:opacity-60 text-white font-semibold py-3.5  transition-colors"
              >
                {loading ? "Sending…" : "Send Reset Link"}
              </button>
            </form>
          </>
        )}
        <Link to="/admin/login" data-testid="forgot-password-back-link" className="mt-6 inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
